export default class EventsList {

    constructor() {
        this.initTabs();
        this.addEvents();
    }

    initTabs() {
        const tab_links = document.querySelectorAll('.event-grid__tab');

        tab_links.forEach(link => {
            link.addEventListener('click', (evt) => {
                tab_links.forEach(link => {
                    link.classList.remove('active');
                })

                this.openTab(evt, link.getAttribute('data-tab'));

            });
        });
    }

    openTab(evt, tabName) {
        const tab_content = document.getElementsByClassName("g-tab-cont");
        for (let i = 0; i < tab_content.length; i++) {
            tab_content[i].style.display = "none";
        }

        const tab_links = document.getElementsByClassName("g-tab-cont__link");

        for (let i = 0; i < tab_links.length; i++) {
            tab_links[i].classList.remove("active");
        }

        document.getElementById(tabName).style.display = "grid";
        evt.currentTarget.classList.add("active");
    }

    addEvents() {
        jQuery(document).ready(function($) {

            let ajaxurl = '/wp-admin/admin-ajax.php';

            $('#load-more-upcoming').on('click', function() {
                const button = $(this);
                const paged = button.data('paged');

                $.ajax({
                    url: ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'load_more_upcoming_events',
                        paged_upcoming: paged + 1,
                        upcoming: true,
                    },
                    success: function(response) {
                        $('#upcoming-content').append(response);
                        button.data('paged', paged + 1);

                        if (response.trim() === '') {
                            button.hide();
                        }
                    }
                });
            });

            $('#load-more-past').on('click', function() {
                const button = $(this);
                let paged = button.data('paged');

                $.ajax({
                    url: ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'load_more_past_events',
                        paged_past: paged + 1,
                        past: true,
                    },
                    success: function(response) {
                        $('#past-content').append(response);
                        button.data('paged', paged + 1);

                        let per_page =  button.data('per-page') + 0;
                        let post_count =  button.data('posts-count') + 0;
                        let next_per_page = per_page * (paged + 1);

                        if (response.trim() === '' || next_per_page >= post_count) {
                            button.hide();
                        }
                    }
                });
            });

        });
    }

}
